import React from 'react';
import CardBody from 'components/Card/CardBody';
import { BodyMBold } from 'components/Typography/Typography';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/dashboard/dashboardStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IProps {
	icon: React.ReactElement;
	text: string;
	value: string | number;
	gradient: types.theme.gradients;
}

const ServiceCard = ({ icon, text, value, gradient }: IProps) => {
	const classes = useStyles();

	return (
		<GridItem xs={12} sm={6} lg={3} className={classes.servicesItem}>
			<Card>
				<CardBody gradient={gradient}>
					<div className={classes.servicesItemIcon}>{icon}</div>
					<div>
						<BodyMBold color={gradient ? 'primary-dark' : 'primary-light'}>{text}</BodyMBold>
						<BodyMBold color={gradient ? 'primary-dark' : 'primary-light'}>{String(value)}</BodyMBold>
					</div>
				</CardBody>
			</Card>
		</GridItem>
	);
};

export default ServiceCard;
